export default "__VITE_ASSET__CrfXCHHA__"